import * as React from 'react';
import PropTypes from 'prop-types';

const MetadataProvider = ({ children }) => {
  return <>{children}</>;
};

MetadataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MetadataProvider;
